import * as yup from "yup";

import { ERRORS_MESSAGE } from "@lhd/constants";

export const validationAppInformation = () => {
  return yup.object().shape({
    name: yup.string().required(ERRORS_MESSAGE["REQUIRED"]),
    categories: yup
      .array()
      .min(1, ERRORS_MESSAGE["REQUIRED"])
      .required(ERRORS_MESSAGE["REQUIRED"]),
  });
};
